var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h3',[_vm._v("Usuarios")]),_vm._l((_vm.users),function(user){return (user)?_c('h1',[_vm._v(_vm._s(user.name))]):_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }